'use es6';

import { Set as ImmutableSet } from 'immutable';
import * as dataTypes from '../constants/dataTypes';
const BLOCKLIST = {
  [dataTypes.CONTACTS]: ImmutableSet(['hs_object_id', 'associatedcompanyid']),
  [dataTypes.DEALS]: ImmutableSet(['hs_object_id']),
  [dataTypes.COMPANIES]: ImmutableSet(['hs_object_id']),
  [dataTypes.ENGAGEMENT]: ImmutableSet(['engagement.details', 'email.text', 'hs_email_text']),
  [dataTypes.TICKETS]: ImmutableSet(['hs_ticket_id'])
};
const getBlocklist = dataType => BLOCKLIST[dataType] || ImmutableSet();
export function isBlocklistedForAggregation(dataType, isCrossObject, property) {
  const isHidden = property.get('hidden');
  const isScripted = property.get('scripted', false);
  const isExplicitlyBlocklisted = getBlocklist(dataType).includes(property.get('name')) || property.get('blocklistedForAggregation');
  return isHidden || isExplicitlyBlocklisted || isCrossObject && isScripted;
}